import axiosRequest from '@/utils/request'

// 上传图片
export const apiUpload = (data) => {
  return axiosRequest({
    url: process.env.VUE_APP_UPLOAD_API + '/file/web/get-upload-info',
    data,
    method: 'post',
    headers: { System: 'wallet' }
  })
}
// 获取授权的imageUrl
export const getObjectUrl = (params) => {
  return axiosRequest({
    url: process.env.VUE_APP_UPLOAD_API + '/file/get-object-url',
    method: 'get',
    params,
    headers: { System: 'wallet' }
  })
}
// 身份证OCR
export const idCardOcr = (params) => {
  return axiosRequest({
    url: '/verified/id-card-ocr',
    method: 'get',
    params
  })
}
// 确认ocr识别结果并返回客户实名状态
export const saveConfirmInfo = (data) => {
  return axiosRequest({
    url: '/verified/save-confirm-info',
    method: 'post',
    data
  })
}
// 低级实名
export const low = (params, { showMessage }) => {
  return axiosRequest({
    url: '/verified/low',
    method: 'get',
    params,
    showMessage
  })
}
// 静默活体识别
export const validateStill = (data) => {
  return axiosRequest({
    url: '/verified/validate-still',
    method: 'post',
    data,
    showMessage: false,
    timeout: 60000
  })
}
// 设置支付密码
export const setUpPayPassword = (data) => {
  return axiosRequest({
    url: '/me/set-up-pay-password',
    method: 'post',
    data
  })
}
// 设置临时密码
export const setTempPayPassword = (data) => {
  return axiosRequest({
    url: '/me/set-up-temp-pay-password',
    method: 'post',
    data
  })
}
// 调用快递接口（是否有线下插卡信息）
export const high = (params) => {
  return axiosRequest({
    url: '/verified/high',
    method: 'get',
    params
  })
}
// 实名步骤
export const getStep = (params) => {
  return axiosRequest({
    url: '/verified/get-step',
    method: 'get',
    params
  })
}
// 激活用户
export const active = (params) => {
  return axiosRequest({
    url: '/verified/active',
    method: 'get',
    params
  })
}

// 获取token 传递给客户端
export const getFaceidToken = (params) => {
  return axiosRequest({
    url: '/verified/get-faceid-token',
    method: 'get',
    params
  })
}

// 客户端校验活体检测结果
export const verifyLivingBody = (data) => {
  return axiosRequest({
    url: '/verified/verify-living-body',
    method: 'post',
    showMessage: false,
    data
  })
}

export const getFileUrl = (params) => {
  return axiosRequest({
    url: process.env.VUE_APP_UPLOAD_API + '/file/get-object-url',
    method: 'get',
    params,
    headers: { System: 'wallet' }
  })
}
